import { createContext } from 'react';

import type { MembershipBottomBannerData } from '#src/app/shared/api/membership';

export const MembershipBottomBannerDataContext = createContext<MembershipBottomBannerData | null>(null);
